import { NewDropdown, Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';
import { useUpdateTag } from 'app/api/tag-queries';

const formatOptions = [
  { label: 'num-dot-decimal', value: 'ixt:num-dot-decimal' },
  { label: 'num-comma-decimal', value: 'ixt:num-comma-decimal' },
  { label: 'num-unit-decimal', value: 'ixt:num-unit-decimal' },
  { label: 'fixed-zero (–)', value: 'ixt:fixed-zero' },
  { label: 'num-words-en', value: 'ixt:num-words-en' },
];

interface FormatFieldProps {
  tagId: string;
  documentSuperId: number;
  currentFormat: string | null;
  disabled?: boolean;
}

export const FormatField = ({ tagId, documentSuperId, currentFormat, disabled = false }: FormatFieldProps) => {
  const { mutate: updateTag } = useUpdateTag();

  const handleUpdate = (format: string) => {
    updateTag({
      id: tagId,
      documentSuperId,
      format: format || null,
    });
  };

  const displayLabel = formatOptions.find((o) => o.value === currentFormat)?.label ?? currentFormat ?? '-';

  return (
    <div className="property-row">
      <Typography fontWeight="semibold" className="property-label">
        {i18n('tag.format.title')}
      </Typography>
      {disabled ? (
        <Typography variant="body-7" fontWeight="light">
          {displayLabel}
        </Typography>
      ) : (
        <div className="format-dropdown">
          <NewDropdown fullwidth options={formatOptions} currentValue={currentFormat ?? i18n('tag.format.choose')} onUpdate={handleUpdate} />
        </div>
      )}
    </div>
  );
};
